<template>
  <Banner></Banner>
  <div style="height: 2rem;"></div>
  <div class="main-desc">
    <WhyNeed></WhyNeed>
    <Offer></Offer>
<!--    <Choose></Choose>-->
  </div>
    <div class="center bottom-download">
      <Download></Download>
      <div style="height: 1.1rem;"></div>
      <div>
        <span>
          客服邮箱: {{email}}
        </span>
      </div>
      <div style="height: 1.1rem;"></div>
    </div>
  <div class="copyright">
    <Copyright></Copyright>
  </div>
  <div class="contact-us"><ContactUs></ContactUs></div>
</template>
<script>
  import Banner from "./components/Banner"
  import WhyNeed from "./components/WhyNeed"
  import Offer from "./components/Offer"
  // import Choose from "./components/Choose"
  import Download from "./components/Download"
  import Copyright from "./components/Copyright"
  import ContactUs from "./components/ContactUs"

  export default {
    name: 'App',
    components: {
      Banner,
      WhyNeed,
      Offer,
      // Choose,
      Download,
      Copyright,
      ContactUs,
    },
  }
</script>
<style>
  * {
    padding: 0;
    margin: 0;
    box-sizing: border-box;
  }

  html {
    font-size: 12px;
    background: linear-gradient(135deg, #f5f7fa 0%, #e8ecf1 100%);
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', sans-serif;
  }

  .center {
    text-align: center;
  }

  .bottom-download {
    min-height: 12rem;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 4rem 2rem;
    position: relative;
    overflow: hidden;
  }

  .bottom-download::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: radial-gradient(circle at 20% 50%, rgba(255,255,255,0.1) 0%, transparent 50%);
    pointer-events: none;
  }

  .bottom-download > div span {
    color: rgba(255,255,255,0.95);
    font-size: 1.1rem;
    font-weight: 500;
    letter-spacing: 0.5px;
  }

  .copyright {
    background: linear-gradient(135deg, #764ba2 0%, #667eea 100%);
    color: white;
  }

  .contact-us{
    position: fixed;
    bottom: 2rem;
    right: 2rem;
    z-index: 1000;
    transition: transform 0.3s ease;
  }

  .contact-us:hover {
    transform: scale(1.05);
  }

  @media all and (min-width: 800px) {
    html {
      font-size: 16px;
    }
    .main-desc {
      max-width: 1200px;
      margin: 0 auto;
      padding: 4rem 5%;
    }
  }

  @media all and (max-width: 799px) {
    .main-desc {
      padding: 2rem 4%;
    }
  }
</style>
